import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'template-attribute-components-menu-dropdown',
  templateUrl: './template-attribute-components-menu-dropdown.component.html',
  styleUrls: ['./template-attribute-components-menu-dropdown.component.scss'],
  standalone: false,
})
export class TemplateAttributeComponentsMenuDropdownComponent {
  @Input() key = 0;
  @Input() isUserComponents = false;
  @Input() componentVisibility = true;
  @Input() componentRequiresUpgrade = false;
  @Input() isDataComponent = false;
  @Input() showVisibilityToggle = true;
  @Input() showDuplicateAction = true;
  @Input() displayName = '';

  @Output() rename = new EventEmitter<number>();
  @Output() visibilityChange = new EventEmitter<boolean>();
  @Output() duplicate = new EventEmitter<number>();
  @Output() remove = new EventEmitter<number>();

  onRename(): void {
    this.rename.emit(this.key);
  }

  onVisibilityChange(visible: boolean): void {
    this.visibilityChange.emit(visible);
  }

  onDuplicate(): void {
    this.duplicate.emit(this.key);
  }

  onRemove(): void {
    this.remove.emit(this.key);
  }
}
